export default "__VITE_ASSET__da3373aa__"